import React from "react";
import { ReleaseDropdown } from "./ReleaseDropdown";

export function ReleaseIconSelect({ task, onTaskChange, className }) {
  return (
    <ReleaseDropdown
      task={task}
      onTaskChange={onTaskChange}
      className={className}
      variant="icon-only"
      showLabel={false}
      size="xs"
    />
  );
}